// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PresentationChartLineIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "PresentationChartLine/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4 4V3H3v1h1Zm16 0h1V3h-1v1ZM6.293 11.293a1 1 0 1 0 1.414 1.414l-1.414-1.414ZM10 9l.707-.707a1 1 0 0 0-1.414 0L10 9Zm3 3-.707.707a1 1 0 0 0 1.414 0L13 12Zm4.707-3.293a1 1 0 0 0-1.414-1.414l1.414 1.414ZM7.293 20.293a1 1 0 1 0 1.414 1.414l-1.414-1.414ZM12 17l.707-.707a1 1 0 0 0-1.414 0L12 17Zm3.293 4.707a1 1 0 0 0 1.414-1.414l-1.414 1.414ZM3 3a1 1 0 0 0 0 2V3Zm18 2a1 1 0 1 0 0-2v2ZM4 5h16V3H4v2Zm15-1v12h2V4h-2Zm0 12H5v2h14v-2ZM5 16V4H3v12h2Zm0 0H3a2 2 0 0 0 2 2v-2Zm14 0v2a2 2 0 0 0 2-2h-2ZM7.707 12.707l3-3-1.414-1.414-3 3 1.414 1.414Zm1.586-3 3 3 1.414-1.414-3-3-1.414 1.414Zm4.414 3 4-4-1.414-1.414-4 4 1.414 1.414Zm-5 9 4-4-1.414-1.414-4 4 1.414 1.414Zm2.586-4 4 4 1.414-1.414-4-4-1.414 1.414ZM3 5h18V3H3v2Z"
}));
export default PresentationChartLineIcon;